import React from 'react'
import { useSelector } from 'react-redux'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconAdd } from 'assets/icons/add.svg'
import ImageDesktop from 'assets/illustrations/providers-empty-state-d.svg'
import ImageMobile from 'assets/illustrations/providers-empty-state-m.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'
import { getUserIsAdmin } from 'services/auth/selectors'

const NoVendors = ({ onClick }) => {
  const t = useTranslation()
  const classes = useStyles()
  const userIsAdmin = useSelector(getUserIsAdmin)

  return (
    <Box my={3} display="flex" flexDirection="column" alignItems="center">
      <Typography variant="h2" gutterBottom className={classes.title}>
        {t('error:no-results-title')}
      </Typography>
      <Box mb={2} maxWidth={440} textAlign="center">
        <Typography variant="subtitle1" color="textSecondary">
          {t('error:no-results-subtitle')}
        </Typography>
      </Box>
      {userIsAdmin ? (
        <Box mb={3}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SvgIcon component={IconAdd} />}
            onClick={onClick}
          >
            {t('error:no-results-action')}
          </Button>
        </Box>
      ) : null}
      <Hidden smUp>
        <img src={ImageMobile} alt="" className={classes.image} />
      </Hidden>
      <Hidden xsDown>
        <img src={ImageDesktop} alt="" className={classes.image} />
      </Hidden>
    </Box>
  )
}

export default NoVendors
